import React, { useContext } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SubmitFormContext } from '../../../context';
import SingleImagePreview from '../SingleImagePreview';
import MultiImagePreview from '../MultiImagePreview';

interface Props {
  className?: string;
}

const ReplaceableImagePreview: React.FC<Props> = props => {
  const { initResponse } = useContext(SubmitFormContext)!;
  const isMultiVideo = useFlag('multi_video');
  const deviation = initResponse?.deviation;
  const useMultiMediaLayout = isMultiVideo
    ? !!deviation?.canBeMultiMedia
    : !!deviation?.canBeMultiImage;

  if (useMultiMediaLayout) {
    return <MultiImagePreview {...props} />;
  }

  return <SingleImagePreview {...props} />;
};
ReplaceableImagePreview.displayName = 'ReplaceableImagePreview';

export default ReplaceableImagePreview;
